import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';

const PublicRoute = ({ children }) => {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        setIsAuth(false);
        return;
      }

      try {
        // Ρωτάμε το backend αν το token είναι όντως σωστό
        const response = await fetch(`${process.env.REACT_APP_API_URL}/verify-auth`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setIsAuth(response.ok);
      } catch (err) {
        setIsAuth(false);
      }
    };

    checkAuth();
  }, []);

  // Όσο περιμένουμε την απάντηση από το backend
  if (isAuth === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress color="warning" />
      </Box>
    );
  }

  // Αν είναι συνδεδεμένος, στείλτον στο dashboard.
  // Αν ΟΧΙ, άφησέ τον να δει τη σελίδα (Login).
  return isAuth ? <Navigate to="/" /> : children;
};

export default PublicRoute;
